/**
 * Tailwind CSS implementation of Label component
 * Uses Seeds label CSS classes from label.css
 *
 * Typography (fontSize / fontWeight / color) continues to flow through the
 * Text child props for exact parity; only the flex layout moves to label.css.
 */

import * as React from "react";
import Text from "@sproutsocial/seeds-react-text";
import { LabelBase } from "./styles";
import type { TypeLabelProps } from "./LabelTypes";

// Utility for merging class names properly
function cn(
  ...inputs: (string | undefined | null | false | Record<string, boolean>)[]
): string {
  const classes: string[] = [];

  for (const input of inputs) {
    if (!input) continue;

    if (typeof input === "string") {
      classes.push(input);
    } else if (typeof input === "object") {
      for (const [key, value] of Object.entries(input)) {
        if (value) {
          classes.push(key);
        }
      }
    }
  }

  return classes.join(" ");
}

export const LabelTailwind = ({
  htmlFor,
  required,
  children,
  className,
  ...rest
}: TypeLabelProps) => {
  return (
    <LabelBase
      className={cn("seeds-label", className)}
      fontSize={200}
      fontWeight="semibold"
      color="text.headline"
      data-qa-label={htmlFor}
      htmlFor={htmlFor}
      {...rest}
    >
      {children}
      {required && (
        <Text ml={100} aria-hidden>
          *
        </Text>
      )}
    </LabelBase>
  );
};

LabelTailwind.displayName = "LabelTailwind";
